<template>
  	<FlexPaymentReport />
</template>

<script>

// @ is an alias to /src
import FlexPaymentReport from "@/components/reports/Flex/PaymentReport.vue";

export default {
  name: "FlexPaymentReportView",
  components: {
    FlexPaymentReport,
  },
};
</script>
